import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule } from "@spartacus/core";
import { CustomLinkListComponent } from './custom-link-list.component';

@NgModule({
    declarations: [CustomLinkListComponent],
    exports: [
        CustomLinkListComponent
    ],
    imports: [
        CommonModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                LinkListComponent: {
                    component: CustomLinkListComponent,
                },
            },
        } as CmsConfig),
    ]
})
export class CustomLinkListModule { }
